import React from 'react';
import loadingImage from '../../images/loading-radar.svg';
import './Loading.scss';
import { t } from 'i18next';

interface IProps {
  title?: string
}

const Loading = ({ title = t("loading.main") }: IProps): React.JSX.Element => {
  return (
    <div className="loading-container d-flex flex-column align-items-center bg-white border p-3 rounded shadow-sm">
      <img src={loadingImage} alt={title} height={50} width={50} />
      <p className="m-0">{title}</p>
    </div>
  )
}

export default Loading;
